import { addFilterScopeStmtInstruction } from './AddFilterScopeStmt';
import { createScopeStmtInstruction } from './CreateScopeStmt';
import { removeFilterScopeStmtInstruction } from './RemoveFilterScopeStmt';
import { removeScopeStmtInstruction } from './RemoveScopeStmt';
export const scopeInstruction = `
## Scopes
- Types: dataGrid, edit, create, detail

### Create scope
Create scope enables users to create new instances of an entity. It's important to include create scopes in the application structure to allow users to create new instances of an entity.

### Edit scope
Edit scope allows for editing existing instances of an entity. It's important to include edit scopes in the application structure to allow users to edit existing instances of an entity.

### List scope (dataGrid)
DataGrid scope is used for listing and displaying instances of an entity, with filtering capabilities. Entities cannot be created or edited in this scope.

### Scope commands

${createScopeStmtInstruction}
${removeScopeStmtInstruction}
${addFilterScopeStmtInstruction}
${removeFilterScopeStmtInstruction}

`;
//# sourceMappingURL=scopeInstruction.js.map